export enum ProjectStatusEnum {
  inProgress = 'In Progress',
  waiting = 'Waiting',
  done = 'Done',
  Pause = 'Pause',
  others = 'Others',
}

// Define a type for the colors corresponding to each episode status
export type ProjectStatusColorType = {
  [K in ProjectStatusEnum]: string; // Maps each status to a string (color code)
};

// Constants for corresponding colors
export const ProjectStatusColors: ProjectStatusColorType = {
  [ProjectStatusEnum.inProgress]: '#FDF58F',
  [ProjectStatusEnum.waiting]: '#C399FA',
  [ProjectStatusEnum.done]: '#77F6A8',
  [ProjectStatusEnum.Pause]: '#C7CACD',
  [ProjectStatusEnum.others]: '#713f12',
};

export enum EpisodeStatusEnum {
  inProgress = 'In Progress',
  waiting = 'Waiting',
  done = 'Done',
  processing = 'Processing',
  Pause = 'Pause',
  canceled = 'Canceled',
  inQueue = "In Queue"

}

// Define a type for the colors corresponding to each episode status
export type EpisodeStatusColorType = {
  [K in EpisodeStatusEnum]: string; // Maps each status to a string (color code)
};

// Constants for corresponding colors
export const EpisodeStatusColors: EpisodeStatusColorType = {
  [EpisodeStatusEnum.inProgress]: '#FDF58F',
  [EpisodeStatusEnum.waiting]: '#C399FA',
  [EpisodeStatusEnum.done]: '#77F6A8',
  [EpisodeStatusEnum.processing]: '#FFBB67',
  [EpisodeStatusEnum.Pause]: '#C7CACD',
  [EpisodeStatusEnum.canceled]: '#F5A6A6',
  // Preferred color indicator for "In Queue"
  [EpisodeStatusEnum.inQueue]: '#8FD3F4',
};

// Example function to get color by status
export const getColorByStatus = (status: EpisodeStatusEnum): string => {
  return EpisodeStatusColors[status];
};
export enum PipelineStatusEnum {
  inProgress = 'In Progress',
  waiting = 'Waiting',
  done = 'Done',
  processing = 'Processing',
}

export enum ServiceStatus {
  inProgress = 'In Progress',
  waiting = 'Waiting',
  done = 'Done',
  processing = 'Processing',
}

export const addFieldsToFormData = (formData: any, fields: any) => {
  Object.keys(fields).forEach((key) => {
    formData.append(key, fields[key]);
  });
};

export function isNotEmpty(obj: unknown) {
  return obj !== undefined && obj !== null && obj !== '';
}

export const calculateDiffTime = (startTime: Date, endTime?: Date): number => {
  if (endTime === undefined) {
    const now = new Date();
    const diff = now.getTime() - startTime?.getTime();
    return diff;
  } else if (endTime) {
    const diff = endTime.getTime() - startTime?.getTime();
    return diff;
  } else return 0;
};

export const padZero = (value: number): string => (value < 10 ? `0${value}` : `${value}`);

export const checkObjEmpty = (obj: any) => {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }

  return true;
};

export function removeUUIDs(sentence: string) {
  // Regular expression for matching UUIDs
  const uuidRegex = /\b[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\b/gi;
  return sentence.replace(uuidRegex, '').trim().replace(/\s+/g, ' ').slice(0, -1); // Trim and remove extra spaces
}

export function containsUUID(sentence: string) {
  // Regular expression for matching UUIDs
  const uuidRegex = /\b[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\b/i;
  return uuidRegex.test(sentence);
}

// Determine the text direction (rtl/ltr) dynamically
export const getDirection = (text: string) => {
  const rtlRegex = /[\u0600-\u06FF]/; // Arabic, Persian, etc.
  return rtlRegex.test(text) ? 'rtl' : 'ltr';
};
